import React from "react";
import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";
import useScreenBreakpoint from "../../../hooks/useScreenBreakpoint";
import { SkeletonContainer } from "./styles";

interface IDoneActivitiesByMonthSkeleton {
  height: number;
  offset?: number;
}

const DoneActivitiesByMonthSkeleton = ({ height, offset }: IDoneActivitiesByMonthSkeleton) => {
  const { isSmallerScreens } = useScreenBreakpoint();

  const LEGEND_SKELETON_HEIGHT = isSmallerScreens ? 150 : 50;
  const GAP = 24;
  const CHART_SKELETON_HEIGHT = height + offset - LEGEND_SKELETON_HEIGHT - GAP;

  return (
    <SkeletonContainer>
      <Skeleton height={CHART_SKELETON_HEIGHT} />
      <Skeleton height={LEGEND_SKELETON_HEIGHT} />
    </SkeletonContainer>
);
};

DoneActivitiesByMonthSkeleton.propTypes = {
    height: PropTypes.number.isRequired,
    offset: PropTypes.number
};

DoneActivitiesByMonthSkeleton.defaultProps = {
  offset: 15
};

export default DoneActivitiesByMonthSkeleton;
